export const DEFAULTS = {
    loading: {
        form: false,
        code: false,
    },
};
